import React, { useEffect, memo } from 'react';
import { View, StyleSheet } from 'react-native';
import Animated, { Easing, useAnimatedStyle, useSharedValue, withRepeat, withTiming, } from 'react-native-reanimated';
import Svg, { G, Path } from 'react-native-svg';
import MaskedView from '@react-native-masked-view/masked-view';
import LinearGradient from 'utils/packages/linearGradient';
import useColors from 'hooks/useColors';
import { isWeb } from '../constants';
// Trimmed so start and end are both at y≈147.9 (same trough) for seamless loop. 4 full waves (8 segments).
const WAVE_PATH_LOOP = 'M338.787 147.896C421.716 296.591 544.597 280 630.186 147.896C726.848 -25.4227 875.118 -38.3913 979.014 147.896C1061.94 296.591 1184.82 280 1270.41 147.896C1367.07 -25.4225 1515.34 -38.391 1619.24 147.897C1702.17 296.591 1825.05 301.359 1910.64 147.897C2007.3 -25.4217 2155.57 -38.3902 2259.47 147.897C2342.4 296.592 2465.28 301.359 2550.87 147.897C2647.53 -25.4215 2795.8 -38.39 2899.69 147.898';
const VIEWBOX_MIN_X = 338.787;
const VIEWBOX_WIDTH = 2560.903; // 2899.69 - 338.787
// Path vertical bounds – used to center wave with equal top/bottom spacing
const PATH_MIN_Y = -38.3913;
const PATH_MAX_Y = 280;
const PATH_HEIGHT = PATH_MAX_Y - PATH_MIN_Y;
const VIEWBOX_HEIGHT = PATH_HEIGHT;
const VIEWBOX_MIN_Y = PATH_MIN_Y;
const DURATION_MS = 45000;
const AnimatedWave = ({ width, height, strokeWidth = 2, rightSpacing = 40, testID, }) => {
    const translateX = useSharedValue(0);
    const segmentWidth = Math.round(width - rightSpacing);
    const colors = useColors();
    useEffect(() => {
        const resetToStart = () => {
            'worklet';
            translateX.value = 0;
        };
        translateX.value = withRepeat(withTiming(-segmentWidth, {
            duration: DURATION_MS,
            easing: Easing.linear,
        }), -1, false, () => {
            resetToStart();
        });
    }, [segmentWidth, translateX]);
    const animatedStyle = useAnimatedStyle(() => ({
        transform: [{ translateX: Math.round(translateX.value) }],
    }));
    const contentWidth = segmentWidth * 2;
    const viewBoxDoubleWidth = VIEWBOX_WIDTH * 2;
    const strokeColor = colors.elements.brand;
    const wave = (<Animated.View style={[{ height }, animatedStyle]}>
      <Svg width={contentWidth} height={height} viewBox={`${VIEWBOX_MIN_X} ${VIEWBOX_MIN_Y} ${viewBoxDoubleWidth} ${VIEWBOX_HEIGHT}`} preserveAspectRatio="none" fill="none" style={styles.svg}>
        <G>
          <Path d={WAVE_PATH_LOOP} stroke={strokeColor} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          <G transform={`translate(${VIEWBOX_WIDTH}, 0)`}>
            <Path d={WAVE_PATH_LOOP} stroke={strokeColor} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          </G>
        </G>
      </Svg>
    </Animated.View>);
    return (<View testID={testID} style={{ paddingRight: rightSpacing }}>
      <View style={styles.overflow}>
        {isWeb ? (
        // On web, MaskedView renders only its mask and drops the wave, so
        // the wave is shown without the fade
        wave) : (<MaskedView style={styles.container} maskElement={<View style={styles.container}>
                <LinearGradient colors={['rgba(0,0,0,0.15)', 'rgba(0,0,0,0.35)', 'black']} start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} style={styles.container}/>
              </View>}>
            {wave}
          </MaskedView>)}
      </View>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    svg: {
        backgroundColor: 'transparent',
        position: 'absolute',
        left: 0,
        top: 0,
    },
    overflow: {
        overflow: 'hidden',
    },
});
export default memo(AnimatedWave);
